import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { observer } from "mobx-react";
import { CAPTCHA_TOKEN_V2 } from "Static/constant";
import "./VerifyCaptcha.scss";

function captchaCallback(token) {
  window.opener.postMessage({ type: "CAPTCHA_TOKEN", value: token }, "*");
}

const VerifyCaptcha = observer(() => {
  return (
    <div className="verify-captcha-page">
      <h2 className="verify-captcha-heading">Verify you are not a bot</h2>
      <ReCAPTCHA
        size="normal"
        badge="bottomleft"
        sitekey={CAPTCHA_TOKEN_V2}
        onChange={captchaCallback}
        isolated
      />
    </div>
  );
});

export default VerifyCaptcha;
